/**
 * PBA Conversion JS — cart upsell + shipping bar + scroll animations
 */
(function () {
  'use strict';

  const FREE_SHIP = 4500; // cents

  /* ── Free shipping bar inside cart drawer ── */
  function updateShipBar() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const fills = document.querySelectorAll('.pba-ship-fill');
      const msgs  = document.querySelectorAll('.pba-ship-bar-msg');
      const pct   = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
      fills.forEach(f => f.style.width = pct + '%');
      msgs.forEach(m => {
        if (cart.total_price >= FREE_SHIP) {
          m.innerHTML = '🎉 <strong>Free shipping unlocked!</strong>';
          fills.forEach(f => f.style.background = '#6B7C5E');
        } else {
          const rem = ((FREE_SHIP - cart.total_price) / 100).toFixed(2);
          m.innerHTML = '🚚 You\'re <strong>$' + rem + ' away</strong> from free shipping!';
        }
      });
    }).catch(() => {});
  }

  /* ── Scroll fade-up ── */
  function initFade() {
    if (!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.pba-review-card, .pba-trust-item, .multicolumn-card, .card-wrapper, .pba-story-content').forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.6s ease ' + (i % 4 * 0.1) + 's, transform 0.6s ease ' + (i % 4 * 0.1) + 's';
      obs.observe(el);
    });
  }

  /* ── Announcement bar rotator ── */
  function rotateAnn() {
    const msgs = [
      '🎁 Free US Shipping on orders $45+ — no code needed!',
      '🧩 Bundle 2+ puzzles and save up to 30% — applied automatically',
      '✊🏾 Black woman-owned · Celebrating Black beauty one piece at a time',
      '🖼️ Each puzzle doubles as frameable wall art',
    ];
    const bar = document.querySelector('.announcement-bar__message p, .announcement-bar__message');
    if (!bar) return;
    let idx = 0;
    setInterval(() => {
      idx = (idx + 1) % msgs.length;
      bar.style.opacity = '0';
      bar.style.transition = 'opacity 0.4s';
      setTimeout(() => { bar.innerHTML = msgs[idx]; bar.style.opacity = '1'; }, 420);
    }, 4500);
  }

  /* ── Listen for cart updates ── */
  document.addEventListener('cart:updated', updateShipBar);
  document.addEventListener('change:success', updateShipBar);

  /* ── MutationObserver for cart drawer opening ── */
  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    new MutationObserver(() => updateShipBar())
      .observe(drawerEl, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  function init() {
    updateShipBar();
    initFade();
    rotateAnn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
